export const getOrganizationProfilesLoaded = (state) => state.organizationProfiles.loaded;

export const getOrganizationProfiles = (state) => state.organizationProfiles.items;

export const getOrganizationProfileById = (state, id) => state.organizationProfiles.items[id];

export const getOrganizationProfileFilterId = (state) => state.organizationProfiles.filterId;
